const participants = {
    links: {
        results: 'Виж резултатите:',
        resultsYear: '2025 г.',
        payment: 'Към плащане за вече регистрирани потребители',
    },
    title: 'Списък с участници:',
    table: {
        name: 'Име',
        category: 'Категория',
        distance: 'Дистанция',
        team: 'Отбор',
        finish: 'Финал',
        status: 'Статус',
        loading: 'Зареждане...',
        with_t_shirt: 'Тениска',
    },
    status: {
        paid: 'Платено',
        pending: 'Очаква плащане',
    },
    counts: {
        distance: 'Дистанция {{distance}} км: {{count}} {{label}}',
        participant: 'участник',
        participants: 'участници',
    },
    profile: {
        backToParticipants: 'Назад към участниците',
        title: 'Участия',
        sections: {
            incoming: 'Предстоящи участия',
            completed: 'Минали участия',
            badges: 'Баджове',
            badgesDescription: 'Предстои',
        },
        table: {
            year: 'Година',
            status: 'Тип',
            checkpoint: 'Контролен пункт',
            distance: 'Дистанция',
            result: 'Резултат',
        },
        status: {
            incoming: 'Предстоящо',
            previous: 'Завършило',
        },
        errors: {
            loadFailed: 'Не успяхме да заредим информацията за участника.',
        },
    },
};

export default participants;
